module.exports = __webpack_public_path__ + "static/media/foto4.98d5e71e.png";